import React from 'react'

function InternalServerErrorIllustration() {
  return (
    <svg
      viewBox="0 0 1149 837"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Internal-server-error"
          transform="translate(-146.000000, -117.000000)"
        >
          <g id="Group-7" transform="translate(146.000000, 117.000000)">
            <path
              d="M48.4810755,790 C36.3128625,736.818639 56.0454385,679.587898 107.678803,618.307776 C185.128848,526.387593 209.191802,505.463286 174.034449,411.574863 C138.877096,317.686441 56.3314535,120.580215 232.885946,33.1948871 C409.440437,-54.1904411 500.434832,55.2858378 593.164138,84.4218073 C685.893444,113.557777 949.863369,184.960095 1051.53443,346.02834 C1153.2055,507.096586 1069.98998,504.99548 1051.53443,627 C1033.07889,749.00452 1093.77068,790 1019.01896,790 C969.184489,790 645.671857,790 48.4810755,790 Z"
              id="Path-2"
              fill="#DFF1F1"
              fillRule="nonzero"
            />
            <circle
              id="Oval-Copy-12"
              fill="#00B8A5"
              fillRule="nonzero"
              cx="964"
              cy="194"
              r="17"
            />
            <g
              id="Group-3"
              transform="translate(487.575796, 299.706101) rotate(-90.000000) translate(-487.575796, -299.706101) translate(427.412924, 179.206101)"
            >
              <circle
                id="Oval-Copy-18"
                fill="#00B8A5"
                fillRule="nonzero"
                cx="17"
                cy="17"
                r="17"
              />
              <circle
                id="Oval-Copy-19"
                fill="#00B8A5"
                fillRule="nonzero"
                cx="87"
                cy="224"
                r="17"
              />
              <path
                d="M17,15 L42.1871693,15 C70.3397931,15 96.4756373,29.6095198 111.223454,53.5901813 L111.223454,53.5901813 L111.223454,53.5901813"
                id="Path-Copy-4"
                stroke="#00B8A5"
                strokeWidth="5"
                strokeLinecap="round"
              />
              <path
                d="M87,224 C53.4948365,194.176704 47.1178276,168.088489 67.8689733,145.735355 C98.9956919,112.205655 120.325745,115.449584 120.325745,86.6184941"
                id="Path-2"
                stroke="#00B8A5"
                strokeWidth="5"
                strokeLinecap="round"
              />
            </g>
            <circle
              id="Oval-Copy-13"
              fill="#00B8A5"
              fillRule="nonzero"
              cx="964"
              cy="403"
              r="17"
            />
            <circle
              id="Oval-Copy-14"
              fill="#00B8A5"
              fillRule="nonzero"
              cx="964"
              cy="612"
              r="17"
            />
            <circle id="Oval-Copy-15" fill="#FFFFFF" cx="964" cy="724" r="17" />
            <circle id="Oval-Copy-16" fill="#FFFFFF" cx="964" cy="509" r="17" />
            <circle id="Oval-Copy-17" fill="#FFFFFF" cx="964" cy="297" r="17" />
            <rect
              id="Rectangle"
              fill="#B2CECE"
              fillRule="nonzero"
              transform="translate(574.500000, 780.000000) rotate(-360.000000) translate(-574.500000, -780.000000) "
              x="0"
              y="770"
              width="1149"
              height="20"
              rx="10"
            />
            <g
              id="Group-2"
              transform="translate(592.000000, 140.000000)"
              fill="#FFFFFF"
              fillRule="nonzero"
              stroke="#252B4C"
              strokeWidth="2"
            >
              <path
                d="M14,0 L357,0 C364.731986,-1.42034288e-15 371,6.2680135 371,14 L371,105 L371,105 L0,105 L0,14 C-9.46895252e-16,6.2680135 6.2680135,1.42034288e-15 14,0 Z"
                id="Rectangle"
              />
              <rect
                id="Rectangle-Copy-6"
                x="0"
                y="105"
                width="371"
                height="105"
              />
              <rect
                id="Rectangle-Copy-7"
                x="0"
                y="210"
                width="371"
                height="105"
              />
              <rect
                id="Rectangle-Copy-8"
                x="0"
                y="315"
                width="371"
                height="105"
              />
              <rect
                id="Rectangle-Copy-10"
                x="0"
                y="420"
                width="371"
                height="105"
              />
              <path
                d="M0,525 L371,525 L371,630 L14,630 C6.2680135,630 9.46895252e-16,623.731986 0,616 L0,525 L0,525 Z"
                id="Rectangle-Copy-11"
              />
            </g>
            <g
              id="Group-2-Copy"
              transform="translate(239.000000, 343.000000)"
              fill="#FFFFFF"
              fillRule="nonzero"
              stroke="#252B4C"
              strokeWidth="2"
            >
              <path
                d="M14,0 L238,0 C245.731986,-1.42034288e-15 252,6.2680135 252,14 L252,71 L252,71 L0,71 L0,14 C-9.46895252e-16,6.2680135 6.2680135,1.42034288e-15 14,0 Z"
                id="Rectangle"
              />
              <rect
                id="Rectangle-Copy-6"
                x="0"
                y="71"
                width="252"
                height="71"
              />
              <rect
                id="Rectangle-Copy-7"
                x="0"
                y="143"
                width="252"
                height="71"
              />
              <rect
                id="Rectangle-Copy-8"
                x="0"
                y="213"
                width="252"
                height="71"
              />
              <rect
                id="Rectangle-Copy-10"
                x="0"
                y="285"
                width="252"
                height="71"
              />
              <path
                d="M0,356 L252,356 L252,413 C252,420.731986 245.731986,427 238,427 L0,427 L0,427 L0,356 Z"
                id="Rectangle-Copy-11"
              />
            </g>
            <g id="Group" transform="translate(306.000000, 429.000000)">
              <g
                id="Group-5-Copy-4"
                opacity="0.319472202"
                transform="translate(121.000000, 0.000000)"
                fill="#FFFFFF"
                fillRule="nonzero"
                strokeLinecap="round"
                strokeWidth="2"
              >
                <line
                  x1="0"
                  y1="15"
                  x2="11"
                  y2="6"
                  id="Path-3"
                  stroke="#252B4C"
                />
                <line
                  x1="5"
                  y1="19.8852955"
                  x2="27.5383065"
                  y2="0.163073255"
                  id="Path-3-Copy"
                  stroke="#00B8A5"
                />
                <line
                  x1="0"
                  y1="32.8852955"
                  x2="22.5383065"
                  y2="13.1630733"
                  id="Path-3-Copy-2"
                  stroke="#252B4C"
                />
                <line
                  x1="16"
                  y1="26.8852955"
                  x2="38.5383065"
                  y2="7.16307326"
                  id="Path-3-Copy-3"
                  stroke="#00B8A5"
                />
                <line
                  x1="12"
                  y1="39.8852955"
                  x2="34.5383065"
                  y2="20.1630733"
                  id="Path-3-Copy-4"
                  stroke="#252B4C"
                />
              </g>
              <rect
                id="Rectangle"
                stroke="#252B4C"
                strokeWidth="2"
                fill="#FFFFFF"
                fillRule="nonzero"
                x="47"
                y="36"
                width="461"
                height="280"
                rx="14"
              />
              <path
                d="M344,46 L484,46 C491.731986,46 498,52.2680135 498,60 L498,292 C498,299.731986 491.731986,306 484,306 L344,306 L344,306 L344,46 Z"
                id="Rectangle-Copy-5"
                fill="#00B8A5"
                fillRule="nonzero"
              />
              <polyline
                id="Path-4"
                stroke="#FFFFFF"
                strokeWidth="14"
                strokeLinecap="round"
                points="337.302945 63 406.36927 135.540875 337.901473 143.95262 406.36927 216.133342"
              />
              <path
                d="M17.9421215,316 L536.057879,316 C540.308184,316 543.753738,319.445553 543.753738,323.695859 C543.753738,325.670377 542.994806,327.569359 541.633929,329 C533.737738,337.300977 522.782438,342 511.325736,342 L42.6742643,342 C31.2175617,342 20.2622616,337.300977 12.3660714,329 C9.43667524,325.920433 9.55841306,321.049205 12.6379805,318.119809 C14.0686216,316.758931 15.9676032,316 17.9421215,316 Z"
                id="Rectangle-Copy"
                stroke="#252B4C"
                strokeWidth="2"
                fill="#FFFFFF"
                fillRule="nonzero"
              />
              <rect
                id="Rectangle-Copy-2"
                stroke="#252B4C"
                strokeWidth="2"
                fillRule="nonzero"
                x="57"
                y="46"
                width="441"
                height="260"
                rx="14"
              />
              <path
                d="M386,205 L456,205 C465.941125,205 474,213.058875 474,223 L474,388 C474,398.49341 465.49341,407 455,407 L387,407 C376.50659,407 368,398.49341 368,388 L368,223 C368,213.058875 376.058875,205 386,205 Z"
                id="Rectangle"
                stroke="#252B4C"
                strokeWidth="2"
                fill="#FFFFFF"
                fillRule="nonzero"
              />
              <path
                d="M387,209 L455,209 C463.284271,209 470,215.715729 470,224 L470,304 L470,304 L429.227286,304 L425.051491,304 L421,304 L372,304 L372,304 L372,224 C372,215.715729 378.715729,209 387,209 Z"
                id="Rectangle-Copy-16"
                fill="#00B8A5"
                fillRule="nonzero"
              />
              <g id="Group-6" transform="translate(378.000000, 216.133342)">
                <path
                  d="M27.9674797,48.8751003 L27.9674797,45.1563503 L20.5203252,45.1563503 L20.5203252,42.2344753 L27.3821138,42.2344753 L27.3821138,38.5157253 L20.5203252,38.5157253 L20.5203252,35.5938503 L28,35.5938503 L28,31.8751003 L16,31.8751003 L16,48.8751003 L27.9674797,48.8751003 Z M35.2461538,48.8751003 L35.2461538,42.1912957 C35.2461538,41.70115 35.3410256,41.273665 35.5307692,40.9088407 C35.7205128,40.5440163 35.9807692,40.2599547 36.3115385,40.0566556 C36.6423077,39.8533565 37.0153846,39.751707 37.4307692,39.751707 C37.6512821,39.751707 37.9153846,39.7712014 38.2230769,39.8101903 C38.5307692,39.8491792 38.7897436,39.9076624 39,39.9856402 L39,39.9856402 L39,36.0505502 C38.8307692,35.9948518 38.6551282,35.9516856 38.4730769,35.9210515 C38.2910256,35.8904174 38.1076923,35.8751003 37.9230769,35.8751003 C37.2923077,35.8751003 36.7423077,36.0839692 36.2730769,36.501707 C35.8038462,36.9194448 35.4615385,37.5794705 35.2461538,38.4817841 L35.2461538,38.4817841 L35.1230769,38.4817841 L35.1230769,36.0421954 L31,36.0421954 L31,48.8751003 L35.2461538,48.8751003 Z M45.2461538,48.8751003 L45.2461538,42.1912957 C45.2461538,41.70115 45.3410256,41.273665 45.5307692,40.9088407 C45.7205128,40.5440163 45.9807692,40.2599547 46.3115385,40.0566556 C46.6423077,39.8533565 47.0153846,39.751707 47.4307692,39.751707 C47.6512821,39.751707 47.9153846,39.7712014 48.2230769,39.8101903 C48.5307692,39.8491792 48.7897436,39.9076624 49,39.9856402 L49,39.9856402 L49,36.0505502 C48.8307692,35.9948518 48.6551282,35.9516856 48.4730769,35.9210515 C48.2910256,35.8904174 48.1076923,35.8751003 47.9230769,35.8751003 C47.2923077,35.8751003 46.7423077,36.0839692 46.2730769,36.501707 C45.8038462,36.9194448 45.4615385,37.5794705 45.2461538,38.4817841 L45.2461538,38.4817841 L45.1230769,38.4817841 L45.1230769,36.0421954 L41,36.0421954 L41,48.8751003 L45.2461538,48.8751003 Z M55.5,48.8751003 C56.8609715,48.8751003 58.0259631,48.6028991 58.9949749,48.0584968 C59.9639866,47.5140944 60.7070771,46.7535725 61.2242462,45.7769311 C61.7414154,44.8002897 62,43.6663461 62,42.3751003 C62,41.0838545 61.7414154,39.9499109 61.2242462,38.9732695 C60.7070771,37.9966281 59.9639866,37.2361062 58.9949749,36.6917039 C58.0259631,36.1473015 56.8609715,35.8751003 55.5,35.8751003 C54.1390285,35.8751003 52.9740369,36.1473015 52.0050251,36.6917039 C51.0360134,37.2361062 50.2929229,37.9966281 49.7757538,38.9732695 C49.2585846,39.9499109 49,41.0838545 49,42.3751003 C49,43.6663461 49.2585846,44.8002897 49.7757538,45.7769311 C50.2929229,46.7535725 51.0360134,47.5140944 52.0050251,48.0584968 C52.9740369,48.6028991 54.1390285,48.8751003 55.5,48.8751003 Z M56.0344828,44.8751003 C55.6091954,44.8751003 55.2442529,44.7539663 54.9396552,44.5116983 C54.6350575,44.2694302 54.4022989,43.9240694 54.2413793,43.4756158 C54.0804598,43.0271622 54,42.493657 54,41.8751003 C54,41.251389 54.0804598,40.7165952 54.2413793,40.2707189 C54.4022989,39.8248426 54.6350575,39.4807704 54.9396552,39.2385024 C55.2442529,38.9962343 55.6091954,38.8751003 56.0344828,38.8751003 C56.4367816,38.8751003 56.7844828,38.9962343 57.0775862,39.2385024 C57.3706897,39.4807704 57.5977011,39.8248426 57.7586207,40.2707189 C57.9195402,40.7165952 58,41.251389 58,41.8751003 C58,42.493657 57.9195402,43.0271622 57.7586207,43.4756158 C57.5977011,43.9240694 57.3706897,44.2694302 57.0775862,44.5116983 C56.7844828,44.7539663 56.4367816,44.8751003 56.0344828,44.8751003 Z M68.2461538,48.8751003 L68.2461538,42.1912957 C68.2461538,41.70115 68.3410256,41.273665 68.5307692,40.9088407 C68.7205128,40.5440163 68.9807692,40.2599547 69.3115385,40.0566556 C69.6423077,39.8533565 70.0153846,39.751707 70.4307692,39.751707 C70.6512821,39.751707 70.9153846,39.7712014 71.2230769,39.8101903 C71.5307692,39.8491792 71.7897436,39.9076624 72,39.9856402 L72,39.9856402 L72,36.0505502 C71.8307692,35.9948518 71.6551282,35.9516856 71.4730769,35.9210515 C71.2910256,35.8904174 71.1076923,35.8751003 70.9230769,35.8751003 C70.2923077,35.8751003 69.7423077,36.0839692 69.2730769,36.501707 C68.8038462,36.9194448 68.4615385,37.5794705 68.2461538,38.4817841 L68.2461538,38.4817841 L68.1230769,38.4817841 L68.1230769,36.0421954 L64,36.0421954 L64,48.8751003 L68.2461538,48.8751003 Z"
                  id="Error"
                  fill="#000000"
                  fillRule="nonzero"
                  opacity="0.16"
                />
                <polygon
                  id="Path-5"
                  fill="#FFFFFF"
                  opacity="0.327034884"
                  points="0 93.1127478 68 0 22 93.1127478"
                />
              </g>
              <rect
                id="Rectangle-Copy-4"
                stroke="#252B4C"
                strokeWidth="2"
                fill="#FFFFFF"
                fillRule="nonzero"
                x="413"
                y="382"
                width="16"
                height="16"
                rx="7"
              />
              <path
                d="M387,209 L455,209 C463.284271,209 470,215.715729 470,224 L470,368 C470,371.313708 467.313708,374 464,374 L421,374 L378,374 C374.686292,374 372,371.313708 372,368 L372,224 C372,215.715729 378.715729,209 387,209 Z"
                id="Rectangle-Copy-3"
                stroke="#252B4C"
                strokeWidth="2"
                fillRule="nonzero"
              />
            </g>
            <circle
              id="Oval"
              fill="#00B8A5"
              fillRule="nonzero"
              cx="914"
              cy="194"
              r="17"
            />
            <circle
              id="Oval-Copy-2"
              fill="#00B8A5"
              fillRule="nonzero"
              cx="914"
              cy="297"
              r="17"
            />
            <circle id="Oval-Copy" fill="#DFF1F1" cx="864" cy="194" r="17" />
            <circle id="Oval-Copy-3" fill="#DFF1F1" cx="864" cy="297" r="17" />
            <circle
              id="Oval-Copy-5"
              fill="#00B8A5"
              fillRule="nonzero"
              cx="914"
              cy="403"
              r="17"
            />
            <circle id="Oval-Copy-4" fill="#DFF1F1" cx="864" cy="403" r="17" />
            <circle
              id="Oval-Copy-7"
              fill="#00B8A5"
              fillRule="nonzero"
              cx="914"
              cy="509"
              r="17"
            />
            <circle id="Oval-Copy-6" fill="#DFF1F1" cx="864" cy="509" r="17" />
            <circle
              id="Oval-Copy-9"
              fill="#00B8A5"
              fillRule="nonzero"
              cx="914"
              cy="612"
              r="17"
            />
            <circle id="Oval-Copy-8" fill="#DFF1F1" cx="864" cy="612" r="17" />
            <circle
              id="Oval-Copy-11"
              fill="#00B8A5"
              fillRule="nonzero"
              cx="914"
              cy="718"
              r="17"
            />
            <circle id="Oval-Copy-10" fill="#DFF1F1" cx="864" cy="718" r="17" />
            <path
              d="M964,190 C1002.93108,190 1034.49096,221.559878 1034.49096,260.490959 L1034.49096,328.509041 C1034.49096,367.440122 1002.93108,399 964,399 L964,399 L964,399"
              id="Path"
              stroke="#00B8A5"
              strokeWidth="5"
            />
            <path
              d="M964,300 C1008.45393,300 1044.49096,336.03703 1044.49096,380.490959 L1044.49096,428.509041 C1044.49096,472.96297 1008.45393,509 964,509 L964,509 L964,509"
              id="Path-Copy"
              stroke="#FFFFFF"
              strokeWidth="5"
            />
            <path
              d="M964,404 C1002.93108,404 1034.49096,435.559878 1034.49096,474.490959 L1034.49096,542.509041 C1034.49096,581.440122 1002.93108,613 964,613 L964,613 L964,613"
              id="Path-Copy-2"
              stroke="#00B8A5"
              strokeWidth="5"
            />
            <path
              d="M964,515 C1008.45393,515 1044.49096,551.03703 1044.49096,595.490959 L1044.49096,643.509041 C1044.49096,687.96297 1008.45393,724 964,724 L964,724 L964,724"
              id="Path-Copy-3"
              stroke="#FFFFFF"
              strokeWidth="5"
            />
            <circle
              id="Oval"
              fill="#00B8A5"
              fillRule="nonzero"
              cx="303.59854"
              cy="380.927007"
              r="9.9270073"
            />
            <circle
              id="Oval-Copy-2"
              fill="#00B8A5"
              fillRule="nonzero"
              cx="303.59854"
              cy="449.072993"
              r="9.9270073"
            />
            <circle
              id="Oval-Copy-20"
              fill="#00B8A5"
              fillRule="nonzero"
              cx="303.59854"
              cy="523.072993"
              r="9.9270073"
            />
            <circle
              id="Oval-Copy"
              fill="#DFF1F1"
              cx="274.40146"
              cy="380.927007"
              r="9.9270073"
            />
            <circle
              id="Oval-Copy-3"
              fill="#DFF1F1"
              cx="274.40146"
              cy="449.072993"
              r="9.9270073"
            />
            <circle
              id="Oval-Copy-21"
              fill="#DFF1F1"
              cx="274.40146"
              cy="523.072993"
              r="9.9270073"
            />
            <circle
              id="Oval-Copy-23"
              fill="#00B8A5"
              fillRule="nonzero"
              cx="303.59854"
              cy="591.072993"
              r="9.9270073"
            />
            <circle
              id="Oval-Copy-22"
              fill="#DFF1F1"
              cx="274.40146"
              cy="591.072993"
              r="9.9270073"
            />
            <circle
              id="Oval-Copy-25"
              fill="#00B8A5"
              fillRule="nonzero"
              cx="303.59854"
              cy="665.072993"
              r="9.9270073"
            />
            <circle
              id="Oval-Copy-26"
              fill="#00B8A5"
              fillRule="nonzero"
              cx="303.59854"
              cy="733.072993"
              r="9.9270073"
            />
            <circle
              id="Oval-Copy-24"
              fill="#DFF1F1"
              cx="274.40146"
              cy="665.072993"
              r="9.9270073"
            />
            <circle
              id="Oval-Copy-27"
              fill="#DFF1F1"
              cx="274.40146"
              cy="733.072993"
              r="9.9270073"
            />
            <g
              id="Group-4"
              transform="translate(435.825564, 244.087141) rotate(-16.000000) translate(-435.825564, -244.087141) translate(405.889180, 204.069014)"
            >
              <path
                d="M11.1820727,0.354111055 C12.2854644,0.354111055 13.1799402,1.2485868 13.1799402,2.35197856 L13.1799402,22.3562436 C13.1799402,23.4596353 12.2854644,24.3541111 11.1820727,24.3541111 C10.0786809,24.3541111 9.18420517,23.4596353 9.18420517,22.3562436 L9.18420517,2.35197856 C9.18420517,1.2485868 10.0786809,0.354111055 11.1820727,0.354111055 Z"
                id="Rectangle"
                fill="#00B8A5"
                transform="translate(11.182073, 12.354111) rotate(-28.000000) translate(-11.182073, -12.354111) "
              />
              <path
                d="M46.6243008,47.3929486 C47.7276925,47.3929486 48.6221683,48.2874244 48.6221683,49.3908161 L48.6221683,77.3950811 C48.6221683,78.4984729 47.7276925,79.3929486 46.6243008,79.3929486 C45.520909,79.3929486 44.6264333,78.4984729 44.6264333,77.3950811 L44.6264333,49.3908161 C44.6264333,48.2874244 45.520909,47.3929486 46.6243008,47.3929486 Z"
                id="Rectangle-Copy-13"
                fill="#00B8A5"
                transform="translate(46.624301, 63.392949) rotate(-210.000000) translate(-46.624301, -63.392949) "
              />
              <path
                d="M32.1068508,0.120879798 C33.2102425,0.120879798 34.1047183,1.01535555 34.1047183,2.1187473 L34.1047183,26.1080864 C34.1047183,27.2114781 33.2102425,28.1059539 32.1068508,28.1059539 C31.003459,28.1059539 30.1089833,27.2114781 30.1089833,26.1080864 L30.1089833,2.1187473 C30.1089833,1.01535555 31.003459,0.120879798 32.1068508,0.120879798 Z"
                id="Rectangle-Copy-9"
                fill="#00B8A5"
                transform="translate(32.106851, 14.113417) rotate(5.000000) translate(-32.106851, -14.113417) "
              />
              <rect
                id="Rectangle-Copy-14"
                fill="#FFFFFF"
                transform="translate(27.551124, 67.036254) rotate(-180.000000) translate(-27.551124, -67.036254) "
                x="25.5511239"
                y="54.036254"
                width="4"
                height="26"
                rx="2"
              />
              <path
                d="M52.0844102,8.495361 C53.187802,8.495361 54.0822777,9.38983675 54.0822777,10.4932285 L54.0822777,29.4974935 C54.0822777,30.6008853 53.187802,31.495361 52.0844102,31.495361 C50.9810185,31.495361 50.0865427,30.6008853 50.0865427,29.4974935 L50.0865427,10.4932285 C50.0865427,9.38983675 50.9810185,8.495361 52.0844102,8.495361 Z"
                id="Rectangle-Copy-12"
                fill="#FFFFFF"
                transform="translate(52.084410, 19.995361) rotate(32.000000) translate(-52.084410, -19.995361) "
              />
              <path
                d="M6.98020401,51.0139515 C8.08359576,51.0139515 8.97807151,51.9084273 8.97807151,53.011819 L8.97807151,70.016084 C8.97807151,71.1194758 8.08359576,72.0139515 6.98020401,72.0139515 C5.87681226,72.0139515 4.98233651,71.1194758 4.98233651,70.016084 L4.98233651,53.011819 C4.98233651,51.9084273 5.87681226,51.0139515 6.98020401,51.0139515 Z"
                id="Rectangle-Copy-15"
                fill="#00B8A5"
                transform="translate(6.980204, 61.513952) rotate(-150.000000) translate(-6.980204, -61.513952) "
              />
            </g>
            <circle id="Oval" fill="#00B8A5" cx="441" cy="242" r="2" />
            <circle id="Oval-Copy-28" fill="#FFFFFF" cx="425" cy="234" r="2" />
            <circle id="Oval-Copy-29" fill="#00B8A5" cx="429" cy="258" r="2" />
            <circle id="Oval-Copy-30" fill="#00B8A5" cx="471" cy="222" r="2" />
            <path
              d="M520.045455,637.454545 L520.045455,623.136364 L490.769886,623.136364 L490.769886,611.886364 L517.744318,611.886364 L517.744318,597.568182 L490.769886,597.568182 L490.769886,586.318182 L520.173295,586.318182 L520.173295,572 L473,572 L473,637.454545 L520.045455,637.454545 Z M546.892045,637.454545 L546.892045,611.886364 C546.892045,610.011364 547.286222,608.376065 548.074574,606.980469 C548.862926,605.584872 549.944247,604.498224 551.318537,603.720526 C552.692827,602.942827 554.242898,602.553977 555.96875,602.553977 C556.884943,602.553977 557.982244,602.628551 559.260653,602.777699 C560.539062,602.926847 561.615057,603.150568 562.488636,603.448864 L562.488636,603.448864 L562.488636,588.395597 C561.785511,588.182528 561.055753,588.017401 560.299361,587.900213 C559.542969,587.783026 558.78125,587.724432 558.014205,587.724432 C555.393466,587.724432 553.10831,588.523438 551.158736,590.121449 C549.209162,591.71946 547.786932,594.244318 546.892045,597.696023 L546.892045,597.696023 L546.380682,597.696023 L546.380682,588.363636 L529.25,588.363636 L529.25,637.454545 L546.892045,637.454545 Z M585.883523,637.454545 L585.883523,611.886364 C585.883523,610.011364 586.277699,608.376065 587.066051,606.980469 C587.854403,605.584872 588.935724,604.498224 590.310014,603.720526 C591.684304,602.942827 593.234375,602.553977 594.960227,602.553977 C595.87642,602.553977 596.973722,602.628551 598.252131,602.777699 C599.53054,602.926847 600.606534,603.150568 601.480114,603.448864 L601.480114,603.448864 L601.480114,588.395597 C600.776989,588.182528 600.04723,588.017401 599.290838,587.900213 C598.534446,587.783026 597.772727,587.724432 597.005682,587.724432 C594.384943,587.724432 592.099787,588.523438 590.150213,590.121449 C588.200639,591.71946 586.778409,594.244318 585.883523,597.696023 L585.883523,597.696023 L585.372159,597.696023 L585.372159,588.363636 L568.241477,588.363636 L568.241477,637.454545 L585.883523,637.454545 Z M628.071023,638.349432 C633.397727,638.349432 637.957386,637.289418 641.75,635.169389 C645.542614,633.049361 648.450994,630.087713 650.475142,626.284446 C652.49929,622.481179 653.511364,618.065341 653.511364,613.036932 C653.511364,608.008523 652.49929,603.592685 650.475142,599.789418 C648.450994,595.986151 645.542614,593.024503 641.75,590.904474 C637.957386,588.784446 633.397727,587.724432 628.071023,587.724432 C622.744318,587.724432 618.184659,588.784446 614.392045,590.904474 C610.599432,593.024503 607.691051,595.986151 605.666903,599.789418 C603.642756,603.592685 602.630682,608.008523 602.630682,613.036932 C602.630682,618.065341 603.642756,622.481179 605.666903,626.284446 C607.691051,630.087713 610.599432,633.049361 614.392045,635.169389 C618.184659,637.289418 622.744318,638.349432 628.071023,638.349432 Z M628.198864,625.309659 C626.622159,625.309659 625.269176,624.808949 624.139915,623.807528 C623.010653,622.806108 622.147727,621.378551 621.551136,619.524858 C620.954545,617.671165 620.65625,615.465909 620.65625,612.909091 C620.65625,610.330966 620.954545,608.120384 621.551136,606.277344 C622.147727,604.434304 623.010653,603.012074 624.139915,602.010653 C625.269176,601.009233 626.622159,600.508523 628.198864,600.508523 C629.690341,600.508523 630.979403,601.009233 632.066051,602.010653 C633.152699,603.012074 633.994318,604.434304 634.590909,606.277344 C635.1875,608.120384 635.485795,610.330966 635.485795,612.909091 C635.485795,615.465909 635.1875,617.671165 634.590909,619.524858 C633.994318,621.378551 633.152699,622.806108 632.066051,623.807528 C630.979403,624.808949 629.690341,625.309659 628.198864,625.309659 Z M678.3125,637.454545 L678.3125,611.886364 C678.3125,610.011364 678.706676,608.376065 679.495028,606.980469 C680.283381,605.584872 681.364702,604.498224 682.738991,603.720526 C684.113281,602.942827 685.663352,602.553977 687.389205,602.553977 C688.305398,602.553977 689.402699,602.628551 690.681108,602.777699 C691.959517,602.926847 693.035511,603.150568 693.909091,603.448864 L693.909091,603.448864 L693.909091,588.395597 C693.205966,588.182528 692.476207,588.017401 691.719815,587.900213 C690.963423,587.783026 690.201705,587.724432 689.434659,587.724432 C686.81392,587.724432 684.528764,588.523438 682.57919,590.121449 C680.629616,591.71946 679.207386,594.244318 678.3125,597.696023 L678.3125,597.696023 L677.801136,597.696023 L677.801136,588.363636 L660.670455,588.363636 L660.670455,637.454545 L678.3125,637.454545 Z"
              id="Error"
              fill="#000000"
              fillRule="nonzero"
              opacity="0.16"
            />
            <g
              id="Group-5"
              opacity="0.319472202"
              transform="translate(615.302945, 158.206468)"
              fill="#FFFFFF"
              fillRule="nonzero"
              strokeLinecap="round"
              strokeWidth="2"
            >
              <line
                x1="0"
                y1="27.7935319"
                x2="18.6865267"
                y2="11"
                id="Path-3"
                stroke="#00B8A5"
              />
              <line
                x1="9"
                y1="35.7935319"
                x2="48.1970548"
                y2="0.293531859"
                id="Path-3-Copy"
                stroke="#252B4C"
              />
              <line
                x1="0"
                y1="58.7935319"
                x2="39.1970548"
                y2="23.2935319"
                id="Path-3-Copy-2"
                stroke="#252B4C"
              />
              <line
                x1="28"
                y1="47.7935319"
                x2="67.1970548"
                y2="12.2935319"
                id="Path-3-Copy-3"
                stroke="#00B8A5"
              />
              <line
                x1="22"
                y1="70.7935319"
                x2="61.1970548"
                y2="35.2935319"
                id="Path-3-Copy-4"
                stroke="#252B4C"
              />
            </g>
            <g
              id="Group-5-Copy"
              opacity="0.319472202"
              transform="translate(615.302945, 264.206468)"
              fill="#FFFFFF"
              fillRule="nonzero"
              strokeLinecap="round"
              strokeWidth="2"
            >
              <line
                x1="0"
                y1="27.7935319"
                x2="18.6865267"
                y2="11"
                id="Path-3"
                stroke="#252B4C"
              />
              <line
                x1="9"
                y1="35.7935319"
                x2="48.1970548"
                y2="0.293531859"
                id="Path-3-Copy"
                stroke="#252B4C"
              />
              <line
                x1="0"
                y1="58.7935319"
                x2="39.1970548"
                y2="23.2935319"
                id="Path-3-Copy-2"
                stroke="#00B8A5"
              />
              <line
                x1="28"
                y1="47.7935319"
                x2="67.1970548"
                y2="12.2935319"
                id="Path-3-Copy-3"
                stroke="#252B4C"
              />
              <line
                x1="22"
                y1="70.7935319"
                x2="61.1970548"
                y2="35.2935319"
                id="Path-3-Copy-4"
                stroke="#252B4C"
              />
            </g>
            <g
              id="Group-5-Copy-2"
              opacity="0.319472202"
              transform="translate(615.302945, 370.206468)"
              fill="#FFFFFF"
              fillRule="nonzero"
              stroke="#252B4C"
              strokeLinecap="round"
              strokeWidth="2"
            >
              <line
                x1="0"
                y1="27.7935319"
                x2="18.6865267"
                y2="11"
                id="Path-3"
              />
              <line
                x1="9"
                y1="35.7935319"
                x2="48.1970548"
                y2="0.293531859"
                id="Path-3-Copy"
              />
              <line
                x1="0"
                y1="58.7935319"
                x2="39.1970548"
                y2="23.2935319"
                id="Path-3-Copy-2"
              />
              <line
                x1="28"
                y1="47.7935319"
                x2="67.1970548"
                y2="12.2935319"
                id="Path-3-Copy-3"
              />
              <line
                x1="22"
                y1="70.7935319"
                x2="61.1970548"
                y2="35.2935319"
                id="Path-3-Copy-4"
              />
            </g>
            <g
              id="Group-5-Copy-3"
              opacity="0.319472202"
              transform="translate(427.000000, 360.000000)"
              fill="#FFFFFF"
              fillRule="nonzero"
              strokeLinecap="round"
              strokeWidth="2"
            >
              <line
                x1="0"
                y1="15"
                x2="11"
                y2="6"
                id="Path-3"
                stroke="#252B4C"
              />
              <line
                x1="5"
                y1="19.8852955"
                x2="27.5383065"
                y2="0.163073255"
                id="Path-3-Copy"
                stroke="#252B4C"
              />
              <line
                x1="0"
                y1="32.8852955"
                x2="22.5383065"
                y2="13.1630733"
                id="Path-3-Copy-2"
                stroke="#252B4C"
              />
              <line
                x1="16"
                y1="26.8852955"
                x2="38.5383065"
                y2="7.16307326"
                id="Path-3-Copy-3"
                stroke="#252B4C"
              />
              <line
                x1="12"
                y1="39.8852955"
                x2="34.5383065"
                y2="20.1630733"
                id="Path-3-Copy-4"
                stroke="#00B8A5"
              />
            </g>
            <polygon
              id="Path-5"
              fill="#FFFFFF"
              opacity="0.327034884"
              points="466.140581 661.072993 632 552 472 671"
            />
          </g>
        </g>
      </g>
    </svg>
  )
}

export default InternalServerErrorIllustration
